var request = require('./request');
var Promise = require('bluebird');
var config = require('./config');
var resolve = require('./resolve');

exports.GetGeoMatchTree = function(filter, publicFacing)
{
	return request.get(resolve(config.url(), '/geomatch/search/?filter=' + filter + '&isPublicFacing=' + publicFacing)).promise()
}

exports.GetFullTree = function(publicFacing) {
  return request.get(resolve(config.url(), '/geomatch?isPublicFacing=' + publicFacing)).promise();
}
